import React from "react";

const Quantity = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3199_732)">
        <rect
          x="4"
          y="4.03125"
          width="16"
          height="16.0104"
          rx="4"
          fill="#EDEEFF"
        />
      </g>
      <path
        d="M8.50319 11.9621C10.1988 11.9556 11.8944 11.949 13.59 11.9425C13.9527 11.9411 14.3174 11.9503 14.68 11.9383C14.8936 11.9528 15.1053 11.9405 15.3152 11.9011C15.3343 12.0041 15.3649 12.1031 15.4072 12.1978C15.7343 12.4539 15.7977 12.6118 16.2392 12.639C16.1623 12.5615 16.0854 12.484 16.0085 12.4065C16.0099 12.9542 16.0114 13.5018 16.0128 14.0495C16.0136 14.354 16.1129 15.03 15.9872 15.2204C15.9033 15.3476 15.6245 15.3575 15.5018 15.5502C15.3763 15.7475 15.3757 15.9825 15.3692 16.2102L15.5999 15.9777C14.4222 15.9743 13.2447 15.9708 12.067 15.9675C11.4781 15.9658 10.8893 15.9641 10.3004 15.9623C9.83666 15.961 9.04594 16.1083 8.62815 15.8591C8.52376 15.7968 8.27746 15.5009 8.19101 15.4086C7.99286 15.1973 8.07275 15.415 8.02501 15.0808C7.98423 14.7953 8.01985 14.4619 8.01744 14.1705C8.01356 13.7043 7.88599 13.0251 8.12706 12.6162C8.29025 12.3394 8.48391 12.2664 8.60404 11.9246C8.70342 11.6418 8.25764 11.5202 8.159 11.8009C7.99152 11.9776 7.82404 12.1544 7.65656 12.3311C7.58517 12.3639 7.54165 12.4566 7.54225 12.5319C7.54995 13.4647 7.34577 14.7106 7.60305 15.6057C7.62502 15.6823 7.68595 15.7488 7.76423 15.7682C8.02506 15.8329 8.22154 16.0778 8.33444 16.3073C8.36993 16.3793 8.45672 16.4223 8.53373 16.4225C10.889 16.4293 13.2444 16.4361 15.5998 16.4429C15.7273 16.4433 15.827 16.336 15.8306 16.2103C15.8429 15.7845 16.3618 15.7136 16.4735 15.3584C16.5858 15.001 16.4752 14.4268 16.4742 14.0496C16.4727 13.5019 16.4713 12.9542 16.4698 12.4065C16.4695 12.2751 16.3641 12.1817 16.2391 12.174C15.943 12.0874 15.774 11.919 15.732 11.6688C15.7119 11.5912 15.6475 11.5269 15.5708 11.5063C15.1794 11.4012 14.7207 11.4731 14.3165 11.4746C13.6504 11.4772 12.9842 11.4797 12.3181 11.4823C11.0464 11.4872 9.77481 11.4922 8.50298 11.497C8.20633 11.4982 8.2058 11.9634 8.50325 11.9622L8.50319 11.9621Z"
        fill="#5F67E0"
      />
      <path
        d="M9.19531 12.6583V15.1237C9.19531 15.423 9.65683 15.4235 9.65683 15.1237V12.6583C9.65683 12.3589 9.19531 12.3585 9.19531 12.6583Z"
        fill="#5F67E0"
      />
      <path
        d="M10.5187 12.752C10.5134 13.5946 10.5149 14.4371 10.5232 15.2797C10.5262 15.5789 10.9877 15.5796 10.9847 15.2797C10.9764 14.4371 10.9749 13.5946 10.9802 12.752C10.9822 12.4526 10.5207 12.4523 10.5187 12.752Z"
        fill="#5F67E0"
      />
      <path
        d="M11.7542 12.752C11.7469 13.5946 11.7491 14.4371 11.7607 15.2797C11.7648 15.5788 12.2264 15.5796 12.2222 15.2797C12.2106 14.4372 12.2085 13.5947 12.2157 12.752C12.2183 12.4526 11.7568 12.4523 11.7542 12.752Z"
        fill="#5F67E0"
      />
      <path
        d="M13.0547 12.7325V15.2135C13.0547 15.5128 13.5162 15.5133 13.5162 15.2135V12.7325C13.5163 12.4332 13.0547 12.4326 13.0547 12.7325Z"
        fill="#5F67E0"
      />
      <path
        d="M14.4071 12.7792C14.425 13.6221 14.4183 14.4644 14.3869 15.3069C14.3758 15.6063 14.8373 15.6058 14.8484 15.3069C14.8797 14.4644 14.8865 13.6221 14.8686 12.7792C14.8623 12.4804 14.4007 12.4793 14.4071 12.7792Z"
        fill="#5F67E0"
      />
      <path
        d="M11.3955 8.17665C11.6557 8.17617 11.9158 8.17577 12.1759 8.1753C12.2864 8.17509 12.4 8.16936 12.5104 8.17469C12.5211 8.06076 12.5023 8.06704 12.454 8.19372C12.4268 8.24306 12.3995 8.2924 12.3723 8.34173C12.2929 8.48563 12.3037 8.50365 12.1524 8.53349C12.0579 8.55205 11.9294 8.55812 11.8356 8.55056C11.7064 8.5401 11.7256 8.55677 11.6612 8.44865C11.588 8.32581 11.536 8.20074 11.495 8.06353C11.4097 7.77756 10.9641 7.89939 11.05 8.18718C11.1397 8.48793 11.3148 8.98326 11.677 9.02174C11.8706 9.04233 12.1284 9.01816 12.3229 8.98698C12.5 8.95857 12.5943 8.8765 12.6891 8.72456C12.8525 8.46288 13.1935 7.96297 12.7716 7.76123C12.5926 7.67564 12.3668 7.70979 12.176 7.71013C11.9158 7.71061 11.6557 7.71101 11.3956 7.71148C11.0985 7.71196 11.098 8.17712 11.3955 8.17665L11.3955 8.17665Z"
        fill="#5F67E0"
      />
      <path
        d="M11.7372 9.02936C11.7372 9.16367 11.7373 9.29805 11.7373 9.43236C11.7373 9.50626 11.7795 9.60224 11.8516 9.63322C11.9315 9.6675 12.002 9.69086 12.0882 9.70321C12.2034 9.71974 12.2522 9.70145 12.2247 9.8471C12.2061 9.9451 12.1653 10.0069 12.0618 10.0282C11.9184 10.0577 11.9121 9.96062 11.8403 9.86107C11.6673 9.62126 11.2667 9.85317 11.4418 10.0959C11.5854 10.2949 11.654 10.5055 11.9401 10.5167C12.1606 10.5253 12.4399 10.4142 12.5671 10.2273C12.6922 10.0436 12.7363 9.75125 12.6522 9.5429C12.6135 9.44726 12.5453 9.3635 12.4542 9.31397C12.3364 9.24992 12.2017 9.28184 12.0846 9.23156C12.1227 9.29851 12.1608 9.36546 12.1989 9.43242C12.1989 9.29811 12.1988 9.16372 12.1988 9.02942C12.1987 8.73002 11.7372 8.72955 11.7372 9.02935L11.7372 9.02936Z"
        fill="#5F67E0"
      />
      <path
        d="M12.1079 10.7164C12.3623 10.8049 12.5832 11.006 12.8315 11.1194C13.0889 11.2369 13.3117 11.3677 13.4862 11.5985C13.6639 11.8335 14.0649 11.602 13.8847 11.3637C13.688 11.1034 13.4597 10.902 13.1645 10.7616C13.0029 10.6848 12.8409 10.6231 12.6905 10.5237C12.5381 10.4229 12.4046 10.3283 12.2305 10.2677C11.9492 10.1699 11.8283 10.6192 12.1078 10.7164L12.1079 10.7164Z"
        fill="#5F67E0"
      />
      <path
        d="M11.8128 10.2675C11.2252 10.6733 10.6318 11.0531 10.0175 11.4166C9.76144 11.568 9.99342 11.9702 10.2504 11.8182C10.8648 11.4548 11.4582 11.0749 12.0458 10.6691C12.2893 10.501 12.0587 10.0976 11.8128 10.2675Z"
        fill="#5F67E0"
      />
      <defs>
        <filter
          id="filter0_d_3199_732"
          x="0"
          y="0.03125"
          width="24"
          height="24.0117"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3199_732"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3199_732"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Quantity;
